/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContentItemSearch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M11 10h7v2h-7zm9.4 9c.4-.6.6-1.3.6-2 0-2.2-1.8-4-4-4s-4 1.8-4 4 1.8 4 4 4c.7 0 1.4-.2 2-.6l2.3 2.3 1.4-1.4zM17 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
      <path d="M4 4h16v8h2V2H2v20h10v-2H4z" />
      <path d="M11 6h7v2h-7zM6 6h3v2H6zm0 8h3v2H6zm0-4h3v2H6z" />
    </g>
  </Icon>
);
export { SvgContentItemSearch as ContentItemSearch };
